import script from "./IconTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./IconTooltip.vue?vue&type=script&setup=true&lang=js"

import "./IconTooltip.vue?vue&type=style&index=0&id=49837674&lang=css"

const __exports__ = script;

export default __exports__